import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { IntegrationService } from './integration.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormBuilder {
  constructor(
    private fb: FormBuilder,
    private integrationService: IntegrationService
  ) { }

  createFormForIntegration(integrationId: number): Observable<{ formGroup: FormGroup, controls: any[] }> {
    console.log(`Creating form for integration ID: ${integrationId}`);

    return this.integrationService.getFormSetup(integrationId).pipe(
      map((configItem) => {
        if (configItem && configItem.reactive_form) {
          const config = configItem.reactive_form;
          console.log(`Form config for integration ID ${integrationId}:`, config);

          const formGroup = this.buildFormFromConfig(config);

          const controls: any[] = [];
          if (config.controls) {
            Object.entries(config.controls).forEach(([key, controlConfig]: [string, any]) => {
              controls.push({ key, config: controlConfig });
            });
          }

          return { formGroup, controls };
        } else {
          console.warn(`No form config found for integration ID ${integrationId}`);
          return {
            formGroup: this.fb.group({}),
            controls: []
          };
        }
      })
    );
  }

  saveFormConfig(formId: number, config: any): Observable<any> {
    console.log(`Saving form config for ${formId}`);
    console.table(config);
    return of({ success: true }).pipe(delay(300));
  }

  private buildFormFromConfig(config: any): FormGroup {
    const formGroup = this.fb.group({}, config.options || {});

    if (config.controls) {
      Object.entries(config.controls).forEach(([key, controlConfig]: [string, any]) => {
        const validators = this.getValidators(controlConfig.validators);
        formGroup.addControl(key, this.fb.control(controlConfig.value, validators));
      });
    }

    console.log('Built form group:', formGroup);
    return formGroup;
  }

  private getValidators(validatorConfig: any): any[] {
    if (!validatorConfig) return [];

    const validators = [];

    if (validatorConfig.required) {
      validators.push(Validators.required);
    }

    if (validatorConfig.minLength) {
      validators.push(Validators.minLength(validatorConfig.minLength));
    }

    if (validatorConfig.pattern) {
      validators.push(Validators.pattern(validatorConfig.pattern));
    }

    return validators;
  }
}
